import { ActionReducer } from '@ngrx/store';
import { Action, ActionTypes } from './actions';

export type State = {
  error: string | undefined;
  isResolving: boolean;
  isAuthenticated: boolean;
  accessToken: string | undefined;
  fullName: string;
};

export const defaultState: State = {
  error: undefined,
  isResolving: false,
  isAuthenticated: false,
  accessToken: undefined,
  fullName: undefined,
};

export const reducer: ActionReducer<State, Action> = (
  state: State = defaultState,
  action: Action,
): State => {
  switch (action.type) {
    case ActionTypes.Login:
    case ActionTypes.LoginSuccess:
    case ActionTypes.LoginFailure:
      return handleLoginAction(state, action);

    case ActionTypes.Logout:
    case ActionTypes.LogoutSuccess:
    case ActionTypes.LogoutFailure:
      return handleLogoutAction(state, action);

    case ActionTypes.ResolveSession:
    case ActionTypes.ResolveSessionSuccess:
    case ActionTypes.ResolveSessionFailure:
      return handleResolveSessionAction(state, action);

    default:
      return state;
  }
};

export function handleLoginAction(state: State, action: Action): State {
  switch (action.type) {
    case ActionTypes.Login:
      return {
        ...state,
        isResolving: true,
        error: undefined,
      };

    case ActionTypes.LoginSuccess:
      return {
        ...state,
        isResolving: false,
        isAuthenticated: true,
        accessToken: action.payload.accessToken,
        fullName: action.payload.fullName,
      };

    case ActionTypes.LoginFailure:
      return {
        ...state,
        isResolving: false,
        error: action.error.error || action.error.message,
      };

    default:
      return state;
  }
}

export function handleLogoutAction(state: State, action: Action): State {
  switch (action.type) {
    case ActionTypes.Logout:
      return {
        ...state,
        isResolving: true,
        error: undefined,
      };

    case ActionTypes.LogoutSuccess:
      return {
        ...state,
        isResolving: false,
        isAuthenticated: false,
        accessToken: undefined,
      };

    case ActionTypes.LogoutFailure:
      return {
        ...state,
        isResolving: false,
        error: action.error.message,
      };

    default:
      return state;
  }
}

export function handleResolveSessionAction(
  state: State,
  action: Action,
): State {
  switch (action.type) {
    case ActionTypes.ResolveSession:
      return {
        ...state,
        isResolving: true,
        error: undefined,
        fullName: action.payload.fullName,
      };

    case ActionTypes.ResolveSessionSuccess:
      return {
        ...state,
        isResolving: false,
        isAuthenticated: !action.payload.expired,
        accessToken: action.payload.accessToken,
      };

    case ActionTypes.ResolveSessionFailure:
      return {
        ...state,
        isResolving: false,
        error: action.error.message,
      };

    default:
      return state;
  }
}

export default reducer;
